import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import logo from '../assets/logo.png';
import './PublicFooter.css';

export default function PublicFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-grid">
          <div className="footer-col footer-brand-col">
            <img src={logo} alt="Hangrily" className="footer-brand-logo" />
            <p className="footer-brand-desc">
              Stop arguing about where to eat. Swipe, match, and discover restaurants you'll both love.
            </p>
            <a href="mailto:support@hangrily.app" className="footer-email">support@hangrily.app</a>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Product</h4>
            <ul>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/locations">Browse Cities</Link></li>
              <li><Link to="/blog">Blog</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Use Cases</h4>
            <ul>
              <li><Link to="/where-should-i-eat">Where Should I Eat?</Link></li>
              <li><Link to="/couples-restaurant-picker">Couples Picker</Link></li>
              <li><Link to="/group-restaurant-decision">Group Decisions</Link></li>
              <li><Link to="/tinder-for-restaurants">Tinder for Restaurants</Link></li>
              <li><Link to="/dinner-decision-app">Dinner Decision App</Link></li>
              <li><Link to="/pick-a-restaurant-for-me">Pick for Me</Link></li>
              <li><Link to="/date-night-restaurants">Date Night</Link></li>
              <li><Link to="/lunch-spot-finder">Lunch Spot Finder</Link></li>
              <li><Link to="/random-restaurant-picker">Random Picker</Link></li>
              <li><Link to="/restaurant-roulette">Restaurant Roulette</Link></li>
              <li><Link to="/restaurant-wheel-alternative">Wheel Alternative</Link></li>
              <li><Link to="/best-restaurants-near-me">Near Me</Link></li>
              <li><Link to="/what-to-eat-tonight">What to Eat Tonight</Link></li>
              <li><Link to="/food-decision-fatigue">Decision Fatigue</Link></li>
              <li><Link to="/cant-decide-what-to-eat">Can't Decide What to Eat</Link></li>
              <li><Link to="/restaurant-voting-app">Restaurant Voting</Link></li>
              <li><Link to="/mood-based-restaurant-finder">Mood Based Finder</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/try">Try Free</Link></li>
              <li><Link to="/register">Get Started</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom-row">
          <p className="footer-copyright">&copy; 2026 Hangrily. All rights reserved.</p>
          <p className="footer-made">Made with 🍕 for hungry people everywhere</p>
        </div>
      </div>

      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'SiteNavigationElement',
            name: [
              'Try Free', 'How It Works', 'Features', 'FAQ', 'Pricing', 'Locations',
              'Where Should I Eat', 'Couples Picker', 'Group Decisions',
              'Tinder for Restaurants', 'Dinner Decision App', 'Pick a Restaurant for Me',
              'Random Picker', 'Restaurant Roulette', 'Date Night', 'Lunch Spot Finder',
              'Best Near Me', 'What to Eat Tonight', 'About', 'Contact', 'Blog'
            ],
            url: [
              'https://hangrily.app/try',
              'https://hangrily.app/how-it-works',
              'https://hangrily.app/features',
              'https://hangrily.app/faq',
              'https://hangrily.app/pricing',
              'https://hangrily.app/locations',
              'https://hangrily.app/where-should-i-eat',
              'https://hangrily.app/couples-restaurant-picker',
              'https://hangrily.app/group-restaurant-decision',
              'https://hangrily.app/tinder-for-restaurants',
              'https://hangrily.app/dinner-decision-app',
              'https://hangrily.app/pick-a-restaurant-for-me',
              'https://hangrily.app/random-restaurant-picker',
              'https://hangrily.app/restaurant-roulette',
              'https://hangrily.app/date-night-restaurants',
              'https://hangrily.app/lunch-spot-finder',
              'https://hangrily.app/best-restaurants-near-me',
              'https://hangrily.app/what-to-eat-tonight',
              'https://hangrily.app/about',
              'https://hangrily.app/contact',
              'https://hangrily.app/blog'
            ]
          })}
        </script>
      </Helmet>
    </footer>
  );
}
